const backendUrl = 'https://www.icanmakemyownapp.com/iqbal/v3/'; 

export {backendUrl}; 
